import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import { getPromiseVoucher, deletePromiseVoucher, deleteAllVouchers } from "../../Web Apis/Apis";
import { message, Pagination, Tooltip } from "antd";
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import Avtar from "../../Images/no image.png";

import ViewVoucher from "./ViewVoucher";
import CreateVoucher from "./CreateVoucher";
import EditVoucher from "./EditVoucher";

import BulkUpload from "./BulkUpload";

import { FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdCancel } from "react-icons/md";

function PromiseVoucher() {
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState({});
  const [allVouchers, setAllVouchers] = useState([]);

  const [showViewVoucherModal, setShowViewVoucherModal] = useState(false);
  const [showCreateVoucherModal, setShowCreateVoucherModal] = useState(false);
  const [showDeleteVoucherModal, setShowDeleteVoucherModal] = useState(false);
  const [showDeleteAllVouchersModal, setShowDeleteAllVouchersModal] = useState(false)

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [showEditVoucherModal, setShowEditVoucherModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");

  const [showBulkUpload, setShowBulkUpload] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // const currentVoucher = allVouchers.slice(indexOfFirstItem, indexOfLastItem);

  const fetchPromiseVoucher = async () => {
    try {
      setLoading(true);

      const sendPage = currentPage - 1;

      const response = await getPromiseVoucher(sendPage, itemsPerPage);
      console.log("clkskscs", response)
       if (response?.data?.success) {
        setAllVouchers(response?.data?.data?.vouchers);
        setTotalPages(response?.data?.data?.totalPages);
        setTotalElements(response?.data?.data?.totalElements);
      }
    } catch (error) {
      console.log("Error while fetch voucher", error.message);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPromiseVoucher();
  }, [currentPage, action]);

  const hanldeDelete = async () => {
    try {
      setLoading(true);
      const response = await deletePromiseVoucher(selectedVoucher);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setShowDeleteVoucherModal(false);
        setAction(!action);
      }
    } catch (error) {
      console.log("Error while delete voucher ...", error.message);
     if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditModalOpen = (data) => {
    setSelectedRow(data);
    setShowEditVoucherModal(true);
  };

  const handleCreateModalOpen = () => {
    setShowCreateVoucherModal(true);
  };

  // const handleUpdateModalOpen = () => {

  // }

  const handleDeleteModalOpen = (voucher) => {
    setSelectedVoucher(voucher);
    setShowDeleteVoucherModal(true);
  };

  const handleViewModalOpen = (voucher) => {
    setSelectedVoucher(voucher);
    setShowViewVoucherModal(true);
  };

  // const imgJson =
  // {
  //   "id": 1744785779466,
  //   "title": "ooen",
  //   "imageUrl": "",
  //   "editableFields": {
  //     "background": { "type": "color", "value": "#73C8D3", "editable": true },
  //     "image_0":
  //     {
  //       "type": "image",
  //       "filePath": "https://javasrvbucket.s3.amazonaws.com/8dbd579c-042b-4ff7-bda3-77ad2a51c69d.png",
  //       "position": { "x": 27.0, "y": 50.0 },
  //       "size": { "width": 218.5, "height": 232.0 },
  //       "scale": 1.4137335789034071,
  //       "rotation": -0.6977777777777776,
  //       "offset": { "x": 0.0, "y": 0.0 },
  //       "editable": true
  //     },
  //     "image_1":
  //     {
  //       "type": "image",
  //       "filePath": "https://javasrvbucket.s3.amazonaws.com/8dbd579c-042b-4ff7-bda3-77ad2a51c69d.png",
  //       "position": { "x": 128.5, "y": 298.5 },
  //       "size": { "width": 205.5, "height": 250.0 },
  //       "scale": 1.0,
  //       "rotation": 0.5233333333333334,
  //       "offset": { "x": 0.0, "y": 0.0 },
  //       "editable": true
  //     },
  //     "text_0":
  //     {
  //       "type": "text",
  //       "text": "Happy Birthday dear the day of the day. Again happy birthday to you dear the text is the best for your family and all yyyy",
  //       "font": "Inter",
  //       "size": 20.0,
  //       "color": "#000000",
  //       "position": { "x": 1.0, "y": 306.5 },
  //       "scale": 1.0,
  //       "rotation": -0.5233333333333334,
  //       "isBold": false,
  //       "isItalic": false,
  //       "isUnderline": false,
  //       "editable": true
  //     },

  //     "text_1":
  //     {
  //       "type": "text",
  //       "text": "hvhvvyyg",
  //       "font": "Inter",
  //       "size": 20.0,
  //       "color": "#000000",
  //       "position": { "x": 50.0, "y": 50.0 },
  //       "scale": 1.0,
  //       "rotation": 0.0,
  //       "isBold": false,
  //       "isItalic": false,
  //       "isUnderline": false,
  //       "editable": true
  //     },
  //     "text_2":
  //     {
  //       "type": "text",
  //       "text": "bsbsbbsbsbdbbdbdbsjjdjdbd jskej sbb w ee",
  //       "font": "Inter",
  //       "size": 20.0,
  //       "color": "#000000",
  //       "position": { "x": 135.5, "y": 125.5 },
  //       "scale": 1.0,
  //       "rotation": 0.0,
  //       "isBold": false,
  //       "isItalic": false,
  //       "isUnderline": false,
  //       "editable": true
  //     }
  //   }
  // }

  const imgJson = {
    layoutName: "Classic Centered Layout (Voucher Style)",
    elements: [
      {
        type: "text",
        content: "I PROMISE TO",
        position: {
          x: "0%",
          y: "0%",
        },
        size: {
          width: "100%",
          height: "auto",
        },
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
          color: "black",
          marginBottom: "10px",
        },
      },
      {
        type: "promise",
        position: {
          x: "0%",
          y: "10%",
        },
        size: {
          width: "100%",
          height: "50px",
        },
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          textAlign: "center",
          color: "#333",
          fontSize: "16px",
          border: "1px dashed #999",
          borderRadius: "8px",
        },
        content: "Promise Text (Centered)",
      },
      {
        type: "image",
        filePath: "https://via.placeholder.com/400x150.png?text=Large+Image",
        position: {
          x: "0%",
          y: "20%",
        },
        size: {
          width: "100%",
          height: "120px",
        },
        style: {
          backgroundColor: "rgba(200, 200, 200, 0.3)",
          borderRadius: "8px",
          margin: "20px 0",
        },
        content: "Large Image Placeholder",
      },
      {
        type: "personal-message",
        position: {
          x: "0%",
          y: "40%",
        },
        size: {
          width: "100%",
          height: "50px",
        },
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          textAlign: "center",
          color: "#333",
          fontSize: "16px",
          border: "1px dashed #999",
          borderRadius: "8px",
        },
        content: "Personal Message",
      },
      {
        type: "sticker",
        position: {
          x: "center",
          y: "50%",
        },
        size: {
          width: "60px",
          height: "60px",
        },
        style: {
          backgroundColor: "#555",
          borderRadius: "50%",
          textAlign: "center",
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        },
        content: "Sticker",
      },
      {
        type: "signature",
        position: {
          x: "0%",
          y: "60%",
        },
        size: {
          width: "100%",
          height: "50px",
        },
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          textAlign: "center",
          color: "#333",
          fontSize: "16px",
          border: "1px dashed #999",
          borderRadius: "8px",
        },
        content: "Signature (Centered)",
      },
    ],
  };

  const handleDownloadExcel = async () => {
    if (!allVouchers || allVouchers.length === 0) return message.error("No data available to download");

    const data = allVouchers?.map((voucher) => ({
      ID: voucher.id,
      Title: voucher.title,
      Description: voucher.description,
      Coin: voucher.coin,
      "Delivery Time Frame": voucher.deliveryTimeFrame,
      "Gift Type": voucher.giftType.join(", "),
      "Emotional Impacts": voucher.emotionalImpacts.join(", "),
      "Age Groups": voucher.ageGroups.join(", "),
      Genders: voucher.genders.join(", "),
      Hobbies: voucher.hobbies.join(", "),
      "Life Stages": voucher.lifeStages.join(", "),
      Locations: voucher.locations.join(", "),
      Occasions: voucher.occasions.join(", "),
      "Personality Types": voucher.personalityTypes.join(", "),
      Personalization: voucher.personalization,
      Relationships: voucher.relationships.join(", "),
      "Relevance Score": voucher.relevanceScore,
      "Send Count": voucher.sendCount,
      "View Count": voucher.viewCount,
      "Deleted?": voucher.deleted ? "Yes" : "No",
      Timestamp: voucher.timestamp,
      "Voucher Type": voucher.voucherType,
      "Image URL": voucher.image,
    }));

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Proimise Vouchers");

    // Generate a binary Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the file using FileSaver
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Vouchers.xlsx");
  };

  const handleExcelUpload = () => {
    setShowBulkUpload(true);
  };


  const handleAllVouchersDelete = async () => {

    try {
      setLoading(true)

      const response = await deleteAllVouchers()
      if(response?.data?.success){
           message.success(response?.data?.message);
          setShowDeleteAllVouchersModal(false)
          setAction(!action)
      }

    } catch (error) {
       console.log("Error while delete all voucher ...", error);
       if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
      else {
        message.error(error?.response?.data?.message || "Error while deleting all vouchers");
      }
      
    } finally {
      setLoading(false)
    }
  }

  const handleAllVOucherDeleteModal = () => {
    setShowDeleteAllVouchersModal(true)
  }

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <h3 className="text-3xl font-bold">Promise Voucher Management</h3>
        <div className="flex justify-end gap-2">
          <button
            onClick={handleCreateModalOpen}
            className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 transition duration-200 text-white font-bold py-2 px-6 rounded"
          >
            Create
          </button>

          <button
            type="button"
            onClick={handleDownloadExcel}
            className="bg-green-200 text-black min-w-fit py-2 px-4 rounded-md hover:bg-yellow-200 transition duration-200 flex items-center justify-center gap-1 whitespace-nowrap"
          >
            <span>Excel</span> <FaDownload />
          </button>

          <button
            onClick={handleExcelUpload}
            className="bg-gray-300 text-black w-36 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Upload Excel
          </button>
        </div>
      </div>

      <table className="min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black">
        <thead>
          <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Title</th>
          <th className="py-2 px-4 border-b text-center">Voucher Image</th>
          <th className="py-2 px-4 border-b text-center">Coins</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
          <Tooltip title="Clear all data">
            <button
              onClick={handleAllVOucherDeleteModal}
              className="text-red-500 hover:text-red-700"
            >
              <MdCancel className="text-3xl" />
            </button>
          </Tooltip>
        </thead>

        <tbody>
          {allVouchers?.length > 0 ? (
            allVouchers?.map((voucher, index) => (
              <tr
                key={voucher.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-300"
                }`}
              >
                <td className="py-2 px-4 border-b">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>
                <td className="py-2 px-4 border-b">{voucher?.title}</td>

                <td className="py-2 px-4 border-b flex justify-center">
                  <img
                    src={voucher?.image || Avtar}
                    alt="voucher"
                    className="w-20 h-20 object-cover border border-gray-700 rounded-full"
                    style={{
                      height: "50px",
                      width: "50px",
                      borderRadius: "50%",
                    }}
                  />
                </td>

                <td className="py-2 px-4 border-b">{voucher?.coin}</td>

                <td className="py-2 px-4 border-b ">
                  <div className="flex flex-row justify-center ">
                    <button
                      onClick={() => handleViewModalOpen(voucher)}
                      className="text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiOutlineEye className="mr-1 text-2xl" />
                    </button>
                    <button
                      onClick={() => handleEditModalOpen(voucher)}
                      className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiFillEdit className="mr-1 text-2xl" />
                    </button>
                    <button
                      onClick={() => handleDeleteModalOpen(voucher)}
                      className="text-red-500 hover:text-red-700 flex items-center"
                    >
                      <AiFillDelete className="mr-1 text-2xl" />
                    </button>
                  </div>
                </td>
                <td></td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="7"
                className=" px-4 py-4 border-b text-center font-bold"
              >
                No promise voucher data found
              </td>
            </tr>
          )}
        </tbody>
        {loading && <Loader />}
      </table>

      <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={totalElements}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>

      {showViewVoucherModal && (
        <ViewVoucher
          showViewVoucherModal={showViewVoucherModal}
          setShowViewVoucherModal={setShowViewVoucherModal}
          selectedVoucher={selectedVoucher}
        />
      )}

      {showCreateVoucherModal && (
        <CreateVoucher
          showCreateVoucherModal={showCreateVoucherModal}
          setShowCreateVoucherModal={setShowCreateVoucherModal}
          action={action}
          setAction={setAction}
        />
      )}

      {showEditVoucherModal && (
        <EditVoucher
          selectedRow={selectedRow}
          showEditVoucherModal={showEditVoucherModal}
          setShowEditVoucherModal={setShowEditVoucherModal}
          action={action}
          setAction={setAction}
        />
      )}

      {/* {showJsonModal && (
        <JsonToImage
          json={imgJson}
          setShowModal={setShowJsonModal}
        />
      )} */}

      {showBulkUpload && (
        <BulkUpload
          action={action}
          setAction={setAction}
          setShowModal={setShowBulkUpload}
        />
      )}

      {showDeleteVoucherModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">
              Confirm Delete
            </h3>
            <p className="mb-4 text-start text-white">
              Are you sure you want to delete this voucher ?{" "}
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => {
                  setShowDeleteVoucherModal(false);
                }}
                className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200"
              >
                Cancel
              </button>
              <button
                onClick={hanldeDelete}
                className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteAllVouchersModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">
              Confirm Delete
            </h3>
            <p className="mb-4 text-start text-white">
              Are you sure you want to delete all vouchers ?{" "}
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => {
                  setShowDeleteAllVouchersModal(false);
                }}
                className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleAllVouchersDelete}
                className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PromiseVoucher;
